import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import Sbt from "src/components/Sbt";
import PlainAppBar from 'src/components/PlainAppBar';

const SbtPage = () => {
  const { id } = useParams();

  const onLoaded = (entry) => {
    document.title = entry.content.titleFull;    
  }

  return (
    <>
      <Box mt={12} ml={4} mr={4}>
        <Sbt id={id} onLoaded={onLoaded}/>
      </Box>
    </>
  );
};

export default SbtPage;
